import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbPaginationModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FiltroMagicoModule } from './../filtro-magico/filtro-magico.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { DatatableComponent } from './datatable.component';
import { DatatableTableComponent } from './components/datatable-table/datatable-table.component';
import { DatatableSortListaComponent } from './components/datatable-sort-lista/datatable-sort-lista.component';
import { DatatablePaginacionLimitComponent } from './components/datatable-paginacion-limit/datatable-paginacion-limit.component';
import { DatatableMostrarColumnasComponent } from './components/datatable-mostrar-columnas/datatable-mostrar-columnas.component';
import { DatatableFiltroMagicoComponent } from './components/datatable-filtro-magico/datatable-filtro-magico.component';
import { DatatableExcelDescargarComponent } from './components/datatable-excel-descargar/datatable-excel-descargar.component';
import { KeepHtmlPipe } from './pipes/keep-html/keep-html.pipe';
import { CustomDatatableComponent } from './components/custom-datatable/custom-datatable.component';
import { CustomDatatableTableComponent } from './components/custom-datatable-table/custom-datatable-table.component';
import { DatatableCellCollapseComponent } from './components/datatable-cell-collapse/datatable-cell-collapse.component';
import { DatatableThListaComponent } from './components/datatable-th-lista/datatable-th-lista.component';
import { DatatableFiltroListaComponent } from './components/datatable-filtro-lista/datatable-filtro-lista.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    NgbPaginationModule,
    NgxSpinnerModule,
    FiltroMagicoModule,
  ],
  exports: [
    DatatableComponent,
    CustomDatatableComponent,
    DatatableCellCollapseComponent,
    DatatableFiltroMagicoComponent,
    DatatableFiltroListaComponent
  ],
  declarations: [
    DatatableFiltroMagicoComponent,
    DatatableMostrarColumnasComponent,
    DatatablePaginacionLimitComponent,
    DatatableSortListaComponent,
    DatatableTableComponent,
    DatatableExcelDescargarComponent,
    DatatableComponent,
    KeepHtmlPipe,
    CustomDatatableComponent,
    CustomDatatableTableComponent,
    DatatableCellCollapseComponent,
    DatatableThListaComponent,
    DatatableFiltroListaComponent
  ],
  bootstrap:[],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DatatableModule { }
